export const forBusiness_realEstate_matter = [
	{
		icon: '💰',
		title: 'matterData_title1',
		subtitle: 'matterData_subtitle1',
	},
	{
		icon: '🤘',
		title: 'matterData_title2',
		subtitle: 'matterData_subtitle2',
	},
	{
		icon: '✨',
		title: 'matterData_title3',
		subtitle: 'matterData_subtitle3',
	},
	{
		icon: '💪',
		title: 'matterData_title4',
		subtitle: 'matterData_subtitle4',
	},
	{
		icon: '💁‍♀️',
		title: 'matterData_title5',
		subtitle: 'matterData_subtitle5',
	},
];
